import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "../../theme";
import { SnackbarProvider } from "notistack";
import { APIContext } from "../../contexts/apiContext";
import type { CustomerInfo } from "../../liquid/snippets/si-customer-info";
import { ErrorBoundary } from "../../bugsnag";
import ErrorView from "../ErrorView";

declare global {
  const siCustomerInfo: CustomerInfo;
  const Shopify: {
    currency: {
      active: string;
    };
    country: string;
  };
}

const container = document.getElementById("loader-reorder");
const baseUrl = container?.getAttribute("data-pc-api-url")?.valueOf() || "";

const locale =
  container?.getAttribute("data-pc-locale")?.valueOf().replace("_", "-") || "";
const root = createRoot(container);
const storeHash =
  container?.getAttribute("data-pc-store-hash")?.valueOf() || "";
const cartPath = container?.getAttribute("data-pc-cart-path")?.valueOf() || "";

root.render(
  <ErrorBoundary FallbackComponent={ErrorView}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        domRoot={document.querySelector("body")}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      />
      <APIContext.Provider
        value={{
          baseUrl,
          currencyCode: Shopify.currency.active,
          shipToCountryCode: Shopify.country,
          locale,
          storeHash,
        }}
      >
        <App cartPath={cartPath} />
      </APIContext.Provider>
    </ThemeProvider>
  </ErrorBoundary>
);
